import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionCodeState: Dtos.InstitutionCode & IRegistrationFormState = {
    id: null,
    institutionId: null,
    institution: null,
    institutionCodingId: null,
    institutionCoding: null,
    codeValue: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    active: null,
}

export interface IInstitutionCodeReduxFormState {
    id: IFieldState<number>,
    institutionId: IFieldState<number>,
    institution: IFieldState<Dtos.Institution>,
    institutionCodingId: IFieldState<number>,
    institutionCoding: IFieldState<Dtos.InstitutionCoding>,
    codeValue: IFieldState<string>
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    active: IFieldState<boolean>,
}
